<div class="variants-list-wrapper"
     [formGroup]="variantsForm">
  <ng-container formArrayName="variants">
    <div [dragulaModel]="variantsFormArray.controls"
         (dragulaModelChange)="orderChanged($event)"
         [dragula]="'PRODUCT_VARIANTS'">
      <div *ngFor="let item of variantsFormArray.controls; let i = index" class="list-item" >
        <div class="variants-list-item joined-input">
          <ng-container [formGroup]="$any(item)">
            <div class="option-name">
              <i class="db-icon db-icon-ds-drag handle"></i>
              <ng-container [formGroup]="$any(item.get('option'))">
                <ds-dropdown [dsDropdownPlaceHolder]="'text_addOption' | dbText"
                             [selectOnEnter]="true"
                             [value]="item.get('option').get('value').valueChanges|async"
                             (onFilterChange)="optionInputChange($event, $any(item))"
                             [dsDropdownWithArrowIcon]="false"
                             [dsDropdownSimpleList]="true"
                             [dsDropdownAddIfEmpty]="true"
                             [dsDropdownKeepInputValue]="true"
                             [selectOnFocusOut]="true"
                             (onFullOptionChoose)="chooseOption($event, $any(item))"
                             formControlName="value"
                             [dsDropdownOptions]="filteredAttributes"
                             [dsDropdownSearch]="true">
                </ds-dropdown>
              </ng-container>
            </div>
            <div class="separator"></div>
            <div class="option-value variants-chip">
              <ng-container [formGroup]="$any(item.get('option_value'))">
                <ds-chip-input [placeholder]="'text_addOptionValue' | dbText"
                               [isDark]="true"
                               [withCheckboxes]="true"
                               [checkboxOptions]="terms[$any(item.get('option')).get('value')?.value]"
                               [showClose]="false"
                               [listForm]="item.get('option_value')|toFormControl">
                </ds-chip-input>
              </ng-container>
            </div>
            <ng-container *ngIf="showApply">
              <div class="separator"></div>
              <div class="apply" [class.dirty]="item.get('option_value').dirty" (click)="onApply($any(item.get('option_value')))">
                {{ 'text_apply' | dbText }}
              </div>
            </ng-container>

          </ng-container>
        </div>
        <div class="remove-variant" (click)="onRemoveItem(i)">
          <i class="db-icon db-icon-ds-remove-outline"></i>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="empty-variants-wrapper">
  <div class="list-item">
    <div class="variants-list-item">
      <ng-container [formGroup]="emptyForm">
        <div class="option-name" [formGroup]="$any(emptyForm.get('option'))">
          <ds-dropdown [dsDropdownPlaceHolder]="'text_addOption' | dbText"
                       [selectOnEnter]="true"
                       [value]="$any(emptyForm.get('option')).get('value').valueChanges|async"
                       (onFilterChange)="optionInputChange($event, $any(emptyForm))"
                       [dsDropdownWithArrowIcon]="false"
                       [dsDropdownSimpleList]="true"
                       [dsDropdownAddIfEmpty]="true"
                       [dsDropdownKeepInputValue]="emptyOptionDropdownKeepValue"
                       [selectOnFocusOut]="true"
                       (onFullOptionChoose)="chooseOption($event, $any(emptyForm))"
                       formControlName="value"
                       [dsDropdownOptions]="filteredAttributes"
                       [dsDropdownSearch]="true">
          </ds-dropdown>
        </div>
        <div class="option-value joined-input">
          <ng-container [formGroup]="$any(emptyForm.get('option_value'))">
            <ds-chip-input [placeholder]="'text_addOptionValue' | dbText"
                           (onAdd)="onEmptyAdd($event)"
                           [isDark]="true"
                           [showClose]="false"
                           [withCheckboxes]="true"
                           [checkboxOptions]="terms[$any(emptyForm.get('option')).get('value')?.value]"
                           [listForm]="emptyForm.get('option_value')|toFormControl">
            </ds-chip-input>
          </ng-container>
          <ng-container *ngIf="showApply">
            <div class="separator"></div>
            <div class="apply" (click)="onApply($any(emptyForm.get('option_value')))">
              Apply
            </div>
          </ng-container>

        </div>
      </ng-container>
    </div>
  </div>
</div>
